module.exports = __webpack_public_path__ + "static/media/user-icon-active.603aa8be.svg";